module.exports = __webpack_public_path__ + "static/mujeres001-1ce1d1667e346987936bba03aa39839c.jpg";